/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import MarkerClusterGroup from "react-leaflet-cluster";
import { Marker, Popup, useMap } from "react-leaflet";
import { Icon, DivIcon } from "leaflet";
import "leaflet.marker.slideto";

import "leaflet-rotatedmarker";

import PositionsPopups from "./Positions-Popups/PositionsPopups";
import { useSelector, useDispatch } from "react-redux";
import { setDevices, setPositions } from "../../Redux/service/Websocket";
import { filtrationcontext } from "../../context/Filtercontext";
import { useLazyGetDevicesByGroupQuery } from "../../Redux/service/Groups/GroupsBack";
import { useLazyGetUsersDeviceQuery } from "../../Redux/service/Devices";
import { livetrackingcontext } from "../../context/LiveTrackingContext";
import { popupcontext } from "../../context/Popupscontext";

// ✅ Memoized marker to avoid re-render
const MemoizedMarker = React.memo(
	({
		position,
		rotation,
		icon,
		popupData,
		deviceStatus,
		device,
		setImei,
		setObjectselect,
		setSelectedId,
	}) => {
		const initialPos = useMemo(() => position, []);
		const markerRef = useRef(null);
		const map = useMap();
		const isInteractingRef = useRef(false);
		const lastUpdateRef = useRef(null);
		useEffect(() => {
			const marker = markerRef.current;
			if (!marker) return;

			const onMouseDown = () => {
				isInteractingRef.current = true;
			};

			const onMouseUp = () => {
				isInteractingRef.current = false;
			};

			const onMouseOut = () => {
				isInteractingRef.current = false;
			};

			const onClick = () => {
				console.log("Marker clicked:", device);
				setSelectedId(device?.id);
				setObjectselect(true);
				setImei(device?.uniqueId);
				map.setView([position[0], position[1]], 13);
			};

			marker.on("mousedown", onMouseDown);
			marker.on("mouseup", onMouseUp);
			marker.on("mouseout", onMouseOut);
			marker.on("click", onClick);

			return () => {
				marker.off("mousedown", onMouseDown);
				marker.off("mouseup", onMouseUp);
				marker.off("mouseout", onMouseOut);
				marker.off("click", onClick);
			};
		}, [device?.uniqueId, setImei, setObjectselect]);

		useEffect(() => {
			const marker = markerRef.current;
			if (!marker || !position) return;

			// ⛔ Pause slideTo while interacting
			if (isInteractingRef.current) {
				marker.setLatLng(position);
				marker.setRotationAngle(rotation || 0);
				return;
			}

			const currentUpdateTime = new Date(device?.lastUpdate || 0).getTime();
			const prevTime = lastUpdateRef.current;

			if (currentUpdateTime && currentUpdateTime !== prevTime) {
				lastUpdateRef.current = currentUpdateTime;

				marker.slideTo(position, {
					duration: 600,
					keepAtLocation: true,
				});
				marker.setRotationAngle(rotation || 0);
			}
		}, [position[0], position[1], rotation, device?.lastUpdate]);

		return (
			<Marker
				ref={markerRef}
				position={initialPos}
				icon={icon}
				rotationOrigin="center"
				interactive
			>
				{/* <Popup autoPan={true}>
					<PositionsPopups
						mark={popupData}
						lat={position[0]}
						lon={position[1]}
						devicestatus={deviceStatus}
					/>
				</Popup> */}
			</Marker>
		);
	},
	(prev, next) =>
		prev.position[0] === next.position[0] &&
		prev.position[1] === next.position[1] &&
		prev.rotation === next.rotation &&
		prev.deviceStatus === next.deviceStatus &&
		prev.icon.options.html === next.icon.options.html &&
		prev.device?.lastUpdate === next.device?.lastUpdate,
);

export default function Positions() {
	const dispatch = useDispatch();
	const positions = useSelector((state) => state.webSocket.positions);
	const devices = useSelector((state) => state.webSocket.devices);
	const wsData = useSelector((state) => state.webSocket.data);
	const inf = useSelector((state) => state.users.user);
	let { trackingType, setImei, setSelectedId } =
		useContext(livetrackingcontext);
	const { parentCheck, filter, isFilterTriggered, trackingTypeIds } =
		useContext(filtrationcontext);
	const { setObjectselect } = useContext(popupcontext);

	const [getUsersDevice] = useLazyGetDevicesByGroupQuery();
	const [getLoggedUserDevice, { data: loggedUserData }] =
		useLazyGetUsersDeviceQuery();
	const [allowedDeviceIds, setAllowedDeviceIds] = useState(new Set());
	const [deviceStatus, setDeviceStatus] = useState({});
	const [handledData, setHandledData] = useState();
	const [devicesData, setDevicesData] = useState([]);
	// console.log("positions", positions);
	// console.log("devices", devices);
	// ✅ Sync WebSocket Data (Fast Maps & Batched Updates)
	useEffect(() => {
		if (!wsData) return;

		const deviceMap = new Map(devices.map((d) => [d.id, d]));
		const posMap = new Map(positions.map((p) => [p.deviceId, p]));
		const newStatus = {};

		wsData.devices?.forEach((d) =>
			deviceMap.set(d.id, { ...deviceMap.get(d.id), ...d }),
		);
		wsData.positions?.forEach((p) => {
			posMap.set(p.deviceId, { ...posMap.get(p.deviceId), ...p });
			const dev = deviceMap.get(p.deviceId);
			if (dev) newStatus[dev.id] = dev.status === "online";
		});

		dispatch(setDevices([...deviceMap.values()]));
		dispatch(setPositions([...posMap.values()]));
		setDeviceStatus((s) => ({ ...s, ...newStatus }));
	}, [wsData]);

	// ✅ Filtering ▶ Fetch device IDs ONLY once
	console.log(
		"isFilterTriggered",
		isFilterTriggered,
		"Filter",
		filter,
		"Parent Check",
		parentCheck,
		"trackingTypeIds",
		trackingTypeIds,
	);
	useEffect(() => {
		if (isFilterTriggered && filter && parentCheck.length > 0) {
			Promise.all(parentCheck.map((id) => getUsersDevice(id))).then(
				(responses) => {
					const ids = responses.flatMap((r) => r?.data?.map((d) => d.id) || []);
					setAllowedDeviceIds(new Set(ids));
				},
			);
		} else {
			getLoggedUserDevice({ userId: inf?.id, type: trackingType }).then(
				(responses) => {
					const mappedObj = responses?.data?.reduce((acc, r) => {
						const traccarId = r?.device?.deviceId;
						if (traccarId) {
							acc[traccarId] = r?.device?.currentUserName || "";
						}
						return acc;
					}, {});
					console.log("MappedObj", mappedObj);
					console.log("ResponsesData", responses?.data);
					setDevicesData((prev) => ({
						...(prev || {}),
						...mappedObj,
					}));
				},
			);

			setAllowedDeviceIds(new Set());
		}
	}, [parentCheck, filter, isFilterTriggered]);
	// ✅ Memoized filtering using Set for O(1)
	const filteredPositions = useMemo(() => {
		if (allowedDeviceIds.size === 0) return positions;
		return positions.filter((p) => allowedDeviceIds.has(p.deviceId));
	}, [positions, allowedDeviceIds]);
	// ✅ Prepare icons only ON DEMAND (memoized)
	const iconCache = useMemo(() => new Map(), []);
	// console.log("filteredPositions", filteredPositions);
	const deviceStatusMap = useMemo(() => {
		const m = new Map();
		(devices || []).forEach((d) => m.set(d.id, d?.status));
		return m;
	}, [devices]);
	useEffect(() => {
		if (trackingTypeIds?.length > 0) {
			setHandledData(
				filteredPositions.filter((p) => trackingTypeIds.includes(p.deviceId)),
			);
		} else {
			setHandledData([]);
		}
	}, [trackingTypeIds, filteredPositions, deviceStatusMap]);
	// useEffect(() => {
	// 	if (trackingTypeIds?.length > 0) {
	// 		setHandledData(
	// 			filteredPositions.filter((p) => {
	// 				return trackingTypeIds.includes(p.deviceId);
	// 			}),
	// 		);
	// 	} else {
	// 		setHandledData([]);
	// 	}
	// }, [trackingTypeIds, filteredPositions]);

	console.log("FilteredPositions", filteredPositions);
	console.log("Handled Data", handledData);
	console.log("DevicesData", devicesData);
	console.log("LoggedUserData", loggedUserData);
	// console.log("PositionsTrackingIds", trackingTypeIds);
	const getIcon = (deviceId) => {
		const device = devices?.find((d) => d.id === deviceId);
		const userName =
			device?.attributes?.current_user_name || devicesData[deviceId] || "";
		const url =
			trackingType === "vehicle"
				? device?.status === "online"
					? `${process.env.PUBLIC_URL}/assets/CarOnline.svg`
					: `${process.env.PUBLIC_URL}/assets/CarOffline.svg`
				: `${process.env.PUBLIC_URL}/assets/New/MobileTracking.svg`;

		const key = `${url}-${deviceId}-${userName}`;
		if (!iconCache.has(key)) {
			console.log("devicesData[deviceId]", devicesData[deviceId]);
			console.log("devicesDataDeviceId", deviceId);
			console.log("Device", device);
			const html =
				trackingType === "vehicle"
					? `
			<div style="display: flex; flex-direction: column; align-items: center;">
				<img src="${url}" style="width: 48px; height: 48px;" />
			</div>
			`
					: `
			<div style="display: flex; flex-direction: column; align-items: center;">
				<img src="${url}" style="width: 48px; height: 48px;" />
				<span style="
					background: white;
					color: black;
					font-size: 10px;
					font-weight: bold;
					padding: 1px 4px;
					border-radius: 4px;
					margin-top: -4px;
					white-space: nowrap;
				">
				
					${userName}
				</span>
			</div>
			`;

			iconCache.set(
				key,
				new DivIcon({
					html,
					className: "custom-marker-label", // avoid default Leaflet styles
					iconSize: [48, 58],
					iconAnchor: [24, 48], // center the icon, adjust popup anchor if needed
				}),
			);
		}

		return iconCache.get(key);
	};
	// console.log("HandledData", handledData);
	return (
		<MarkerClusterGroup chunkedLoading>
			{handledData?.map((p) => (
				<MemoizedMarker
					key={p.deviceId}
					position={[p.latitude, p.longitude]}
					rotation={p.course}
					icon={getIcon(p.deviceId)}
					popupData={p}
					deviceStatus={deviceStatus[p.deviceId] ?? false}
					device={devices.find((d) => d.id === p.deviceId)}
					setImei={setImei}
					setObjectselect={setObjectselect}
					setSelectedId={setSelectedId}
				/>
			))}
		</MarkerClusterGroup>
	);
}
